import { Observable } from 'rxjs'
import { filter, tap } from 'rxjs/operators'
import Member from 'iam/models/Member'
import { FreshbooksHubspotAPI } from 'freshbooks/API'
import { Id } from 'types/definitions'
import UserData from 'iam/models/UserData'
import { UserDataType } from 'iam/models/UserDataType'

/**
 * HubSpot integration
 */
export function HubspotIntegration(
  currentMember$: Observable<Member>,
  freshbooksAPI: FreshbooksHubspotAPI,
  token$: Observable<string>,
  getUserDataByUserPublicId: (userPublicId: Id) => UserData | null,
) {
  token$.subscribe(() => {
    currentMember$
      .pipe(
        filter((member) => !member.email.toLowerCase().includes('e2e-')),
        filter(
          (member) => !member.workspace.name.toLowerCase().includes('e2e-'),
        ),
        tap((member) => {
          const userData = getUserDataByUserPublicId(member.user.publicId)

          if (userData?.userDataType === UserDataType.Pro) {
            freshbooksAPI.getToken().then((token) => {
              window.hsConversationsSettings = {
                identificationEmail: member.email,
                identificationToken: token,
              }

              window.HubSpotConversations.widget.load()
            })
          }
        }),
      )
      .subscribe()
  })
}
